export const playKeys = {
  worldComments: id => ["worldComments", id],
  worldRecomments: commentId => ["worldRecomments", commentId],
  worldDetail: params => ["worldDetail", params],
};
